import React from 'react';
import cerebro from 'assets/images/cerebro-1.png';
import elem1 from 'assets/images/red-elem1.png';
import elem2 from 'assets/images/red-elem2.png';
import elem3 from 'assets/images/red-elem3.png';
import elem4 from 'assets/images/red-elem4.png';
import elem5 from 'assets/images/red-elem5.png';
import elem6 from 'assets/images/red-elem6.png';
import elem7 from 'assets/images/red-elem7.png';
import { Link } from 'react-router-dom';

export default function RicoData() {
  return (
    <div className='red'>
      <div className="elems">
        <img src={elem1} className='elem1' alt="" />
        <img src={elem2} className='elem2' alt="" />
        <img src={elem3} className='elem3' alt="" />
        <img src={elem4} className='elem4' alt="" />
        <img src={elem5} className='elem5' alt="" />
        <img src={elem6} className='elem6' alt="" />
        <img src={elem7} className='elem7' alt="" />
      </div>
      <div className="logo">
        <h3>Rico en Data</h3>
      </div>
      <figure>
        <img src={cerebro} className='cerebro' alt="Imagen de cerebro" />
      </figure>
      <p className='copy'>Ahora la educación financiera llega<br />a las aulas bonaerenses</p>
      <div className="cta">
        <Link className="btn-verde" to="/rico-en-data">Conocé más</Link>
      </div>
      <span className='spacer'></span>
    </div>
  );
}